import northernIcon from '../../assets/northern-property-management-icon.png'
import { POINTS, PRACTICAL, STEPS } from './helpers'
import {
  ApprovedStamp,
  ArtApprove,
  ArtCompany,
  ArtHeader,
  ArtLine,
  ArtLogo,
  ArtTag,
  ArtTotal,
  ArtifactCard,
  ArtifactStage,
  Container,
  Cta,
  CtaBody,
  CtaHeading,
  CtaInner,
  CtaLink,
  CtaRow,
  Eyebrow,
  Footer,
  FooterBrand,
  FooterLink,
  FooterMeta,
  Hero,
  HeroCopy,
  HeroGrid,
  HeroLead,
  HeroTitle,
  Page,
  PointBody,
  PointRow,
  PointTitle,
  Practical,
  PracticalBody,
  PracticalGrid,
  PracticalItemBox,
  PracticalTitle,
  PrimaryLink,
  SectionEyebrow,
  StepBody,
  StepBox,
  StepNumber,
  StepTitle,
  Steps,
  StepsGrid,
  Substance,
  Thesis,
  ThesisLine,
  ThesisSub,
  TrustLine,
  ViewedChip,
} from './styled'

const QUICKCASA_URL = 'https://quickcasa.ai'

const MarketingPage = () => (
  <Page>
    <Hero>
      <Container>
        <HeroGrid>
          <HeroCopy>
            <Eyebrow>QuickCasa Quotes</Eyebrow>
            <HeroTitle>From quote to signed.</HeroTitle>
            <HeroLead>
              The quoting tool for property managers. Each person gets their own
              link, you see the moment they open it, and the yes lands on
              record. <b>No chasing. No guessing where it stands.</b>
            </HeroLead>
            <CtaRow>
              <PrimaryLink href={QUICKCASA_URL}>Explore QuickCasa</PrimaryLink>
              <TrustLine>Part of the QuickCasa leasing platform.</TrustLine>
            </CtaRow>
          </HeroCopy>

          <ArtifactStage>
            <ViewedChip>Dana opened this - 2 min ago</ViewedChip>
            <ArtifactCard>
              <ArtHeader>
                <ArtLogo src={northernIcon} alt="Northern Property Management" />
                <ArtCompany>Northern Property Management</ArtCompany>
                <ArtTag>Quote - v2</ArtTag>
              </ArtHeader>
              <ArtLine>
                <span>Unit 4B turnover</span>
                <span>$2,450</span>
              </ArtLine>
              <ArtLine>
                <span>Interior repaint</span>
                <span>$1,180</span>
              </ArtLine>
              <ArtLine>
                <span>Carpet, 2 bedrooms</span>
                <span>$740</span>
              </ArtLine>
              <ArtTotal>
                <span>Total</span>
                <span>$4,370</span>
              </ArtTotal>
              <ArtApprove>Approve quote</ArtApprove>
            </ArtifactCard>
            <ApprovedStamp>Approved</ApprovedStamp>
          </ArtifactStage>
        </HeroGrid>
      </Container>
    </Hero>

    <Thesis>
      <Container>
        <ThesisLine>
          A quote is a question. Most of them just sit in an inbox,{' '}
          <em>unanswered</em>.
        </ThesisLine>
        <ThesisSub>
          QuickCasa gets you to the yes, and shows you exactly how it got there.
        </ThesisSub>
      </Container>
    </Thesis>

    <Substance>
      <Container>
        <SectionEyebrow>Why it works</SectionEyebrow>
        {POINTS.map(point => (
          <PointRow key={point.title}>
            <PointTitle>{point.title}</PointTitle>
            <PointBody>{point.body}</PointBody>
          </PointRow>
        ))}
      </Container>
    </Substance>

    <Practical>
      <Container>
        <PracticalGrid>
          {PRACTICAL.map(item => (
            <PracticalItemBox key={item.title}>
              <PracticalTitle>{item.title}</PracticalTitle>
              <PracticalBody>{item.body}</PracticalBody>
            </PracticalItemBox>
          ))}
        </PracticalGrid>
      </Container>
    </Practical>

    <Steps>
      <Container>
        <SectionEyebrow>How it works</SectionEyebrow>
        <StepsGrid>
          {STEPS.map(step => (
            <StepBox key={step.number}>
              <StepNumber>{step.number}</StepNumber>
              <StepTitle>{step.title}</StepTitle>
              <StepBody>{step.body}</StepBody>
            </StepBox>
          ))}
        </StepsGrid>
      </Container>
    </Steps>

    <Container>
      <Cta>
        <CtaInner>
          <CtaHeading>Quoting is where the deal gets done.</CtaHeading>
          <CtaBody>
            QuickCasa answers, qualifies, and follows up with your rental leads
            across phone, text, email, and web. Quoting is the part that turns a
            maybe into a signature.
          </CtaBody>
          <CtaLink href={QUICKCASA_URL}>See the whole platform</CtaLink>
        </CtaInner>
      </Cta>
    </Container>

    <Container>
      <Footer>
        <FooterBrand>QuickCasa</FooterBrand>
        <FooterMeta>Built in Canada</FooterMeta>
        <FooterLink href={QUICKCASA_URL}>quickcasa.ai</FooterLink>
      </Footer>
    </Container>
  </Page>
)

export default MarketingPage
